module.exports = __webpack_public_path__ + "static/media/connectino-logo-en-blue.12632f84.svg";